import { ReactNode } from 'react'
import clsx from 'clsx'
import { SectionWithListWithAssetPageSchema } from 'cms/schemaTypes/staticPages/documents/sectionListWithAsset'

import FormattedText from 'shared/ui/FormattedText'

import HowItWorks from '../../components/deliveryInfo/HowItWorks'
import { InfoBox, PageTitle, SectionContainer } from '../../components/landings/styles'

import styles from './DeliveryCost.module.scss'

interface DeliveryCostTexts {
  header: string
  content: string | ReactNode
  infoBox: string | ReactNode
  steps: {
    title: string
    description: string | ReactNode
  }[]
}

interface DeliveryCostProps {
  texts: DeliveryCostTexts
  howItWorks: SectionWithListWithAssetPageSchema
}
const DeliveryCost = ({ texts, howItWorks }: DeliveryCostProps) => {
  const [featureStep, ...steps] = texts.steps

  return (
    <>
      <SectionContainer $condensed>
        <PageTitle>
          <FormattedText text={texts.header} />
        </PageTitle>
        <div className={styles.textContent}>{texts.content}</div>
        <div className={styles.stepsWrapper}>
          <div className={styles.step}>
            <h3 className={clsx(styles.stepTitle, styles.featuredStepTitle)}>
              <FormattedText text={featureStep.title} />
            </h3>
            <div className={styles.stepDescription}>{featureStep.description}</div>
          </div>
          {steps.map(step => (
            <div key={step.title} className={styles.step}>
              <h3 className={styles.stepTitle}>
                <FormattedText text={step.title} />
              </h3>
              <div className={styles.stepDescription}>{step.description}</div>
            </div>
          ))}
        </div>
        <InfoBox>{texts.infoBox}</InfoBox>
      </SectionContainer>
      <HowItWorks content={howItWorks} />
    </>
  )
}

export default DeliveryCost
